import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import { Loading } from "@ebsco-ui/ebsco-ui";
import GenericError from "../generic-error";
import {
  getSecretQuestions,
  getSecretQuestionsError,
  getSecretQuestionsLoading,
  fetchSecretQuestions
} from "../../store/secret-questions";
import getIsCoppa from "../../store/coppa";

import sharedMessages from "../../../shared-messages";

function withSecretQuestions(WrappedComponent) {
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }

  return class extends Component {
    static displayName = `withSecretQuestions(${getDisplayName(
      WrappedComponent
    )})`;

    componentDidMount() {
      const { secretQuestions, fetchSecretQuestions, isCoppa } = this.props;

      if (isCoppa && !secretQuestions.length) {
        fetchSecretQuestions();
      }
    }

    render() {
      const {
        error,
        intl: { formatMessage },
        isCoppa,
        loading,
        fetchSecretQuestions,
        secretQuestions,
        ...passThroughProps
      } = this.props;
      if (isCoppa && error) {
        return <GenericError />;
      }
      if (isCoppa && loading) {
        return (
          <Loading loadingMessage={formatMessage(sharedMessages.loading)} />
        );
      }
      return <WrappedComponent {...passThroughProps} />;
    }
  };
}

const mapStateToProps = state => ({
  error: getSecretQuestionsError(state),
  loading: getSecretQuestionsLoading(state),
  secretQuestions: getSecretQuestions(state),
  isCoppa: getIsCoppa(state)
});

const mapDispatchToProps = { fetchSecretQuestions };

export { withSecretQuestions };
export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withSecretQuestions
);
